import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Constant } from '../constant/constant';
import { LoginService } from './login.service';
import { EcryptServiceService } from './ecrypt-service.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionsService {

  private trialExpiredMessageSubject = new BehaviorSubject<string | null>(null);
  trialExpiredMessage$ = this.trialExpiredMessageSubject.asObservable();

  constructor(private http: HttpClient, private router: Router,
    private loginService: LoginService,
    private ecryptService: EcryptServiceService
  ) {
    this.loadInitialTrialMessage();
  }

  url = environment.serverAPI4 + "/api";

  url1 = environment.serverAPI4 + "/api";


  url2 = environment.serverAPI7 + "/api";

  checkSubscription(): Observable<Object> {
    return this.http.get(`${this.url}/check/status`);
  }

  makePayment(payment: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url1}/paymentSubscription`, payment);
  }

  makePaymentSubsciptions(payment: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url2}/ig/registration/create`, payment);
  }



  checkUserExpired(): Observable<Object> {
    return this.http.get(`${this.url}/user/check/expired`);
  }

  getLatestPaymentSubscriptiondata(): Observable<any> {
    return this.http.get(`${this.url}/paymentSubscription/latest`
    );
  }

  checkFreeTrail(): Observable<Object> {
    return this.http.get(`${this.url}/account/free/trial/check`);
  }

  getSubscriptionSummary(productId?: number): Observable<Object> {

    let basicAuthHeaderString = '';

    if (Constant.DEVICE_TYPE == "MOBILE") {
      basicAuthHeaderString = this.loginService.getStorageToken(
        Constant.X_XSRF_TOKEN
      );
    } else {
      basicAuthHeaderString = this.loginService.getStorageToken(
        Constant.X_XSRF_TOKEN
      );
    }

    if (basicAuthHeaderString != null && basicAuthHeaderString != undefined && basicAuthHeaderString != "") {
      const url = productId != null ? `${this.url}/subscription/summary?productId=${productId}` : `${this.url}/subscription/summary`;
      return this.http.get(url);
    }

    return throwError(() => new Error('No authentication token available'));
  }

  getSubscriptionHistoryPaged(page: number = 0, size: number = 20, sort: string = 'id,desc'): Observable<Object> {
    return this.http.get(`${this.url}/subscription/history/paged?page=${page}&size=${size}&sort=${encodeURIComponent(sort)}`);
  }

  getPricingPreview(payload: any): Observable<Object> {
    return this.http.post(`${this.url}/subscription/pricing-preview`, payload);
  }

  getPricingProducts(): Observable<Object> {
    return this.http.get(`${this.url}/pricing/products`);
  }

  getPlanFeatures(): Observable<Object> {
    return this.http.get(`${this.url}/planFeatures`);
  }

  getPricingBillingCycles(): Observable<Object> {
    return this.http.get(`${this.url}/pricing/billing-cycles`);
  }

  getPricingCurrencies(): Observable<Object> {
    return this.http.get(`${this.url}/pricing/currencies`);
  }

  getPricingPlans(product: string, billingCycle: string, currency: string, users?: number): Observable<Object> {
    let requestUrl = `${this.url}/pricing/plans?product=${encodeURIComponent(product)}&billingCycle=${encodeURIComponent(billingCycle)}&currency=${encodeURIComponent(currency)}`;
    if (users != null) {
      requestUrl += `&users=${users}`;
    }
    return this.http.get(requestUrl);
  }

  getPricingCurrentSubscription(customerId: string = 'self', product?: string): Observable<Object> {
    let requestUrl = `${this.url}/pricing/current/${encodeURIComponent(customerId)}`;
    if (product) {
      requestUrl += `?product=${encodeURIComponent(product)}`;
    }
    return this.http.get(requestUrl);
  }

  previewPricingChange(payload: any): Observable<Object> {
    return this.http.post(`${this.url}/pricing/preview-change`, payload);
  }

  confirmPricingChange(payload: any): Observable<Object> {
    return this.http.post(`${this.url}/pricing/change-plan`, payload);
  }

  navigateToPlanSelection(context: any): Promise<boolean> {
    return this.router.navigate(['/subscription/plan-selection'], { state: context || {} });
  }

  // Fetch the most recent payment subscription (page=0,size=1,sort=id,desc)
  getLatestPaymentSubscription(): Observable<any> {
    return this.http.get(`${this.url}/paymentSubscription?page=0&size=1&sort=id,desc`);
  }

  checkoutSubscription(payload: any): Observable<Object> {
    return this.http.post(`${this.url}/subscription/checkout`, payload);
  }

  manualCheckoutSubscription(payload: any): Observable<Object> {
    return this.http.post(`${this.url}/admin/subscription/manual`, payload);
  }

  updateSubscription(): Observable<Object> {
    return this.http.post(`${this.url}/updateAccount/plan`, {});
  }

  applySubscriptionCoupon(couponCode: string, subtotal: number): Observable<any> {
    return this.http.post(`${this.url}/subscription/coupon/apply`, { couponCode, subtotal });
  }

  // ---- Add-on & Renewal-with-addons ----------------------------------------

  /** Get available add-on catalogue for a product. */
  getAvailableAddons(productCode?: string): Observable<any> {
    const params = productCode ? `?product=${encodeURIComponent(productCode)}` : '';
    return this.http.get(`${this.url}/pricing/addons${params}`);
  }

  /** Get all add-ons attached to the calling tenant's subscription. */
  getMyAddons(): Observable<any> {
    return this.http.get(`${this.url}/pricing/my-addons`);
  }

  /**
   * Full renewal preview including plan + addons + GST.
   * GET /api/pricing/renewal-preview
   */
  getRenewalWithAddonsPreview(productCode?: string): Observable<any> {
    const params = productCode ? `?product=${encodeURIComponent(productCode)}` : '';
    return this.http.get(`${this.url}/pricing/renewal-preview${params}`);
  }

  /**
   * Mark an addon as EXCLUDED_FROM_RENEWAL (not deleted).
   * POST /api/pricing/remove-addon-from-renewal
   */
  removeAddonFromRenewal(subscriptionAddonId: number): Observable<any> {
    return this.http.post(`${this.url}/pricing/remove-addon-from-renewal`, { subscriptionAddonId });
  }

  /**
   * Finalise renewal of plan + all active addons after payment succeeds.
   * Optionally purchases new add-ons (newAddons) in the same call.
   * Rules enforced server-side: PLAN-type addons limited to 1 per renewal.
   * POST /api/pricing/renew-with-addons
   */
  renewWithAddons(payload: {
    productCode?: string;
    transactionId?: string;
    paymentModeType?: string;
    paymentStatus?: string;
    manualReferenceNo?: string;
    remarks?: string;
    newAddons?: Array<{
      addonCode: string;
      quantity: number;
      overrideUnitPrice?: number;
      overrideGstPercentage?: number;
    }>;
  }): Observable<any> {
    return this.http.post(`${this.url}/pricing/renew-with-addons`, payload);
  }


  updateTrialExpiredMessage(message: string | null): void {
    this.trialExpiredMessageSubject.next(message);
    if (message !== null) {
      try {
        const encrypted = this.ecryptService.encryptionAES(JSON.stringify(message));
        localStorage.setItem('trialExpiredMessage', encrypted);
      } catch (e) {
        console.warn('Failed to encrypt and store trialExpiredMessage:', e);
      }
    } else {
      localStorage.removeItem('trialExpiredMessage');
    }
  }

  loadInitialTrialMessage(): void {
    try {
      const encrypted = localStorage.getItem('trialExpiredMessage');
      if (encrypted) {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        if (decrypted && decrypted !== '') {
          const parsed = JSON.parse(decrypted);
          this.trialExpiredMessageSubject.next(parsed);
          return;
        }
      }
    } catch (e) {
      console.error('Failed to load/decrypt trialExpiredMessage from localStorage:', e);
    }
    this.trialExpiredMessageSubject.next(null);
  }

  /**
   * Detects trial/subscription type, calculates remaining days,
   * and returns the appropriate notification message (or empty string if none).
   */
  getSubscriptionMessage(account: any): string {
    if (!account) {
      return '';
    }

    const plan = account.plan || localStorage.getItem('plan');
    if (plan === '5' || plan === 5) {
      return '';
    }

    const isFreeTrial = account.freeTrail === 1 || account.freeTrail === '1' || account.freeTrail === true;

    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (isFreeTrial) {
      const expiryDateStr = account.trailExipryDate;
      if (!expiryDateStr) {
        return '';
      }
      const expiryDate = new Date(expiryDateStr);
      if (isNaN(expiryDate.getTime())) {
        return '';
      }

      const end = new Date(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate());
      const diffDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

      if (diffDays > 7) {
        return '';
      }

      if (diffDays > 0) {
        return `Your trial expires in ${diffDays} day${diffDays > 1 ? 's' : ''}`;
      } else if (diffDays === 0) {
        return 'Your trial expires today';
      } else {
        return 'Your trial has expired';
      }
    } else {
      const renewalDateStr = account.renewalDate;
      if (!renewalDateStr) {
        return '';
      }
      const renewalDate = new Date(renewalDateStr);
      if (isNaN(renewalDate.getTime())) {
        return '';
      }

      const end = new Date(renewalDate.getFullYear(), renewalDate.getMonth(), renewalDate.getDate());
      const diffDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

      if (diffDays > 7) {
        return '';
      }

      if (diffDays > 0) {
        return `Your subscription expires in ${diffDays} day${diffDays > 1 ? 's' : ''}`;
      } else if (diffDays === 0) {
        return 'Your subscription expires today';
      } else {
        return 'Your subscription has expired';
      }
    }
  }
}

